import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BaseService } from '../../base/util/base.service';
import { adminBuscarComunicados, adminInserirComunicado, adminExcluirComunicado, adminDadosCadastraisPrestador } from '../../base/util/url-util';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Comunicado } from '../../base/vo/comunicado';

@Injectable()
export class AdminComunicadosService extends BaseService {

    constructor(public http: HttpClient,public messageService: MessageService) { 
        super(http,messageService);
    }
    
    buscarComunicados(nPagina: number, nItemsPerPage: number) {
    	return this.get(adminBuscarComunicados(true, nPagina - 1, nItemsPerPage));
    }
    
    publicarComunicado(comunicado:Comunicado, imagem:any) {
    	let fd: FormData = new FormData();
    	
    	fd.append('comunicadoDTO', new Blob([JSON.stringify(comunicado)],{type: "application/json"}));
    	
        if(imagem && imagem.size>0){
			fd.append('imagem', imagem, imagem.name);
		} else {
			fd.append('imagem', null);
		}
		
        return this.post(adminInserirComunicado(), fd, new HttpHeaders().set('Accept', 'application/json'));
    }
    
    excluirComunicado(id: string) {
    	return this.get(adminExcluirComunicado(id));
    }
    
    buscarDadosPrestador(codigo: string) {
    	return this.get(adminDadosCadastraisPrestador(codigo));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/admin/comunicados/admin-comunicados.service.ts